import { TapeBuilderUI } from '@finley-technologies/tape-builder';

// This helps manage testing / exposing non-released nodes so users won't
// have option to select it in the UI when authoring graphs.
// Switch case may be empty if no nodes are being tested at the moment
const availableUiNodes = TapeBuilderUI.uiNodes.filter(({ nodeType }) => {
  // some nodes are not available for selection in the UI based on their type
  switch (nodeType) {
    case 'operation_pdf2csv': // use 'operation_pdf2csv':
    case 'operation_xlsx2csv': // use xlsx2csv2
    case 'db_node': // this is a monitor mode only node
    case 'file_configTape': // use config store.
    case 'file_valley_bank_ingest': // valley bank specific.
    case 'file_valley_bank_sls_commitment': // valley bank specific.
    case 'file_valley_bank_sls_ingest': // valley bank specific.
      return false;
    // replaced by
    default:
      return true;
  }
});

export const rawNodes: TapeBuilderUI.TapeBuilderNodeType[] = availableUiNodes
  .filter((uiNode) => !uiNode.isOperation && uiNode.isRaw)
  .map(({ nodeType }) => nodeType);

export const operationNodes: TapeBuilderUI.TapeBuilderNodeType[] = availableUiNodes
  .filter(({ isOperation }) => isOperation)
  .map(({ nodeType }) => nodeType);

export const generatedNodes: TapeBuilderUI.TapeBuilderNodeType[] = availableUiNodes
  .filter((node) => !node.isOperation && !node.isRaw)
  .map(({ nodeType }) => nodeType);

export const allNodeTypes = availableUiNodes.map(({ nodeType }) => nodeType);

export const isValidNodeType = (type: TapeBuilderUI.TapeBuilderNodeType) => {
  return allNodeTypes.includes(type);
};
